import {QueryEntry} from 'common/widgets/query-event-selector/types';
import {ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {Segment, getSegmentType} from 'common/widgets/query-block/segment-menu/types';

/**
 * Sanitizes exclusionSteps by fixing out of range step selections
 */
export function sanitizeExclusionSteps(exclusionSteps: QueryEntry[], events: QueryEntry[]): QueryEntry[] {
  return exclusionSteps.map((step) => {
    if (step.excludeRange.to > events.length) {
      step.excludeAll = true;
      step.excludeRange = {};
    }

    return step;
  });
}

/**
 * Sanitizes group-by entries when a cohort is selected
 */
export function sanitizeGroupBys(events: QueryEntry[], segments: Segment[][]) {
  const isMultiGroupBy = Array.isArray(segments) && segments.length && Array.isArray(segments[0]);
  const eventsOnlyEntries = events.every((entry) => (entry.type || ResourceType.Event) === ResourceType.Event);
  const peopleOnlyEntries = events.length > 0 && events.every((entry) => entry.type === ResourceType.User);
  segments = isMultiGroupBy ? segments.filter((segment) => Array.isArray(segment) && segment.length) : segments;

  if (peopleOnlyEntries) {
    const allowedTypes = [ResourceType.User, ResourceType.Cohort];
    segments = segments.filter((segment) => allowedTypes.includes(getSegmentType(segment)));
  } else if (!eventsOnlyEntries) {
    segments = segments.filter((segment) => getSegmentType(segment) === ResourceType.Cohort);
  }

  return segments;
}
